import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import './AchievementToast.css';

function AchievementToast({
  achievement,
  playerName,
  onClose,
  customTitle,
  customContent,
  dismissible = true,
  autoDismissTime = 5000,
  icon,
  inline = false,
}) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Auto-dismiss after specified time (or never if autoDismissTime is null/0)
    if (autoDismissTime && autoDismissTime > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(onClose, 300); // Wait for animation to complete
      }, autoDismissTime);

      return () => clearTimeout(timer);
    }
  }, [onClose, autoDismissTime]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  if (!achievement && !customTitle) return null;

  const getAchievementIcon = () => {
    if (icon === null) return null; // Allow explicit null to hide icon
    if (icon) return icon;
    if (achievement?.levelUp) return '🛡️';
    if (achievement?.type === 'streak') return '🔥';
    if (achievement?.type === 'points') return '🎯';
    if (achievement?.type === 'equipment') return '⚽';
    return '🏆';
  };

  const getAchievementTitle = () => {
    if (customTitle) return customTitle;
    if (achievement?.levelUp) return 'LEVEL UP!';
    if (achievement?.type === 'streak') return 'STREAK MILESTONE!';
    if (achievement?.type === 'points') return 'POINTS MILESTONE!';
    if (achievement?.type === 'equipment') return 'EQUIPMENT GUIDE';
    return 'ACHIEVEMENT UNLOCKED!';
  };

  const getContent = () => {
    if (customContent) return customContent;
    if (achievement?.message) {
      return playerName
        ? `${playerName} ${achievement.message}`
        : achievement.message;
    }
    return achievement?.name || '';
  };

  const toastClass = inline
    ? `achievement-toast inline ${isVisible ? 'visible' : 'hidden'}`
    : `achievement-toast ${isVisible ? 'visible' : 'hidden'}`;

  return (
    <div className={toastClass}>
      <div className='toast-content'>
        {!inline && getAchievementIcon() && (
          <div className='toast-icon'>{getAchievementIcon()}</div>
        )}
        <div className='toast-info'>
          <div className='toast-title'>{getAchievementTitle()}</div>
          <div
            className='toast-message'
            dangerouslySetInnerHTML={{ __html: getContent() }}
          />
        </div>
        {dismissible && (
          <button className='toast-close' onClick={handleClose}>
            <X size={20} />
          </button>
        )}
      </div>
    </div>
  );
}

export default AchievementToast;
